import { render, staticRenderFns } from "./ClienteDetalle.vue?vue&type=template&id=63c28960&scoped=true"
import script from "./ClienteDetalle.vue?vue&type=script&lang=js"
export * from "./ClienteDetalle.vue?vue&type=script&lang=js"
import style0 from "./ClienteDetalle.vue?vue&type=style&index=0&id=63c28960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c28960",
  null
  
)

export default component.exports